import {
  Box,
  Card,
  CardContent,
  Grid2 as Grid,
  Skeleton,
  Typography
} from '@mui/material'

const DiagnosticDetailSkeleton = () => {
  return (
    <Box sx={{ padding: 2, width: '100%', maxWidth: 1200, margin: '0 auto' }}>
      {/* Header Skeleton */}
      <Grid container spacing={2} alignItems='center' mb={3}>
        <Grid size={12} paddingBlock={2}>
          {/* Back button skeleton */}
          <Skeleton variant='rectangular' width={200} height={40} />
        </Grid>
        <Grid size={6}>
          {/* Title skeleton */}
          <Skeleton variant='text' width={300} height={40} />
        </Grid>
        <Grid size={12} container spacing={1} direction='column'>
          {/* Info items skeleton */}
          <Skeleton variant='text' width={250} height={20} />
          <Skeleton variant='text' width={280} height={20} />
          <Skeleton variant='text' width={200} height={20} />
          <Skeleton variant='text' width={220} height={20} />
        </Grid>
      </Grid>

      {/* Exam Visualization Section Skeleton */}
      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Grid container spacing={2}>
            <Grid size={12}>
              {/* ECG/Exam title skeleton */}
              <Skeleton variant='text' width={300} height={30} sx={{ mb: 2 }} />

              {/* ECG Grid Skeleton - 3 rows of 4 leads each */}
              <Grid container spacing={0} sx={{ mb: 1 }}>
                {new Array(4).map((_, index) => (
                  <Grid size={3} key={'row1-' + index}>
                    <Skeleton
                      variant='rectangular'
                      width='100%'
                      height={100}
                      sx={{ border: '1px solid #e0e0e0' }}
                    />
                  </Grid>
                ))}
              </Grid>

              <Grid container spacing={0} sx={{ mb: 1 }}>
                {new Array(4).map((_, index) => (
                  <Grid size={3} key={'row2-' + index}>
                    <Skeleton
                      variant='rectangular'
                      width='100%'
                      height={100}
                      sx={{ border: '1px solid #e0e0e0' }}
                    />
                  </Grid>
                ))}
              </Grid>

              <Grid container spacing={0} sx={{ mb: 2 }}>
                {new Array(4).map((_, index) => (
                  <Grid size={3} key={'row3-' + index}>
                    <Skeleton
                      variant='rectangular'
                      width='100%'
                      height={100}
                      sx={{ border: '1px solid #e0e0e0' }}
                    />
                  </Grid>
                ))}
              </Grid>

              {/* Rhythm strip skeleton */}
              <Skeleton
                variant='rectangular'
                width='100%'
                height={120}
                sx={{ border: '1px solid #e0e0e0', mb: 2 }}
              />

              {/* Legends skeleton */}
              <Skeleton variant='text' width={150} height={20} />
              <Skeleton variant='text' width={200} height={16} />
              <Skeleton variant='text' width={180} height={16} />
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      {/* Diagnosis Section Skeleton */}
      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Skeleton variant='text' width={200} height={30} sx={{ mb: 2 }} />

          {/* Diagnosis cards skeleton */}
          {new Array(3).map((_, index) => (
            <Card
              key={'diagnosis-' + index}
              sx={{ mb: 2, border: '1px solid #e0e0e0' }}
            >
              <CardContent sx={{ py: 2 }}>
                <Grid container spacing={2} justifyContent='space-between'>
                  <Grid size={7}>
                    <Skeleton
                      variant='text'
                      width='80%'
                      height={25}
                      sx={{ mb: 1 }}
                    />
                    <Skeleton
                      variant='text'
                      width='100%'
                      height={16}
                      sx={{ mb: 0.5 }}
                    />
                    <Skeleton
                      variant='text'
                      width='90%'
                      height={16}
                      sx={{ mb: 0.5 }}
                    />
                    <Skeleton
                      variant='text'
                      width='85%'
                      height={16}
                      sx={{ mb: 0.5 }}
                    />
                    <Skeleton
                      variant='text'
                      width='95%'
                      height={16}
                      sx={{ mb: 0.5 }}
                    />
                    <Skeleton variant='text' width='75%' height={16} />
                  </Grid>
                  <Grid
                    size={5}
                    container
                    direction='column'
                    alignItems='flex-end'
                    spacing={1}
                  >
                    <Grid>
                      <Skeleton variant='rectangular' width={180} height={32} />
                    </Grid>
                    <Grid>
                      <Skeleton variant='rectangular' width={180} height={32} />
                    </Grid>
                    <Grid>
                      <Skeleton variant='rectangular' width={180} height={32} />
                    </Grid>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          ))}

          {/* Add diagnosis button skeleton */}
          <Skeleton
            variant='rectangular'
            width={200}
            height={40}
            sx={{ mt: 1 }}
          />
        </CardContent>
      </Card>

      {/* Medical Report Section Skeleton */}
      <Grid container mb={3}>
        <Grid size={12}>
          <Skeleton variant='text' width={250} height={30} sx={{ mb: 2 }} />
          <Skeleton
            variant='rectangular'
            width='100%'
            height={120}
            sx={{ borderRadius: 1 }}
          />
        </Grid>
      </Grid>

      {/* Technical Feedback Section Skeleton */}
      <Grid container mb={3}>
        <Grid size={12}>
          <Skeleton variant='text' width={300} height={30} sx={{ mb: 2 }} />
          <Skeleton
            variant='rectangular'
            width='100%'
            height={90}
            sx={{ borderRadius: 1 }}
          />
        </Grid>
      </Grid>

      {/* Generate Report Button Skeleton */}
      <Grid container justifyContent='flex-end'>
        <Grid size='auto'>
          <Skeleton
            variant='rectangular'
            width={150}
            height={45}
            sx={{ borderRadius: 1 }}
          />
        </Grid>
      </Grid>
    </Box>
  )
}

export default DiagnosticDetailSkeleton
